import * as React from "react";
import { Button, ButtonGroup } from "@progress/kendo-react-buttons";

export type ButtonDataInfo = {
  key: string;
  text: string | JSX.Element;
};

export const ButtonGroupContainer: React.FunctionComponent<{
  buttonData: Array<ButtonDataInfo>;
  onSelect: (buttonData: ButtonDataInfo) => void;
}> = ({ buttonData, onSelect }) => {
  const [selected, setSelected] = React.useState<string>("0");

  const groupButtonClick = (info: ButtonDataInfo) => {
    setSelected(info.key);
    onSelect(info);
  };

  const isSelected = (index: string) => {
    return index === selected ? true : false;
  };

  return (
    <ButtonGroup>
      {buttonData.map((buttonInfo) => {
        return (
          <Button
            key={buttonInfo.key}
            togglable={true}
            id={buttonInfo.key}
            selected={isSelected(buttonInfo.key)}
            onClick={() => {
              groupButtonClick(buttonInfo);
            }}
          >
            {buttonInfo.text}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};
